import { FC } from 'react';

import { AdfoxBannerContainer } from '../../../AdfoxBannerContainer';
import { AdfoxContextProvider, AdfoxContextProviderProps } from '../../context/AdfoxContext';

import { SpecialProjectBannerSkeleton } from './internal/components/SpecialProjectBannerSkeleton';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  isSp: true,
  place: 'above_offers',
};

const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 174 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'dmepr', p2: 'hyhj' };

export const SpecialProjectBanner: FC = () => {
  return (
    <SpecialProjectBannerSkeleton>
      <AdfoxContextProvider pParams={P_PARAMS} postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA} size={SIZE}>
        <AdfoxBannerContainer hideOnStub={false} />
      </AdfoxContextProvider>
    </SpecialProjectBannerSkeleton>
  );
};
